import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { legalPages } from '../../pages/Legal/legalContent';
import './LegalDialog.css';

const SLUGS = ['terms', 'privacy', 'accessibility', 'cookies', 'sitemap'];

export default function LegalDialog({ isOpen, onClose, slug }) {
  const [cookiesAnalytics, setCookiesAnalytics] = useState(true);
  const [cookiesMarketing, setCookiesMarketing] = useState(false);

  const normalizedSlug = slug && SLUGS.includes(slug) ? slug : null;
  const page = normalizedSlug ? legalPages[normalizedSlug] : null;
  const isCookies = normalizedSlug === 'cookies';

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', handleEscape);
    }
    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !page) return null;

  const dialog = (
    <div className="legal-dialog-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="legal-dialog-title">
      <div className="legal-dialog-box" onClick={(e) => e.stopPropagation()}>
        <div className="legal-dialog-header">
          <h2 id="legal-dialog-title" className="legal-dialog-title">{page.title}</h2>
          <button type="button" className="legal-dialog-close" onClick={onClose} aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
        <p className="legal-dialog-updated">Last updated: {page.lastUpdated}</p>
        <div className="legal-dialog-body">
          {page.sections.map((section, i) => (
            <section key={i} className="legal-dialog-section">
              <h3 className="legal-dialog-section-heading">{section.heading}</h3>
              <p className="legal-dialog-section-body">{section.body}</p>
            </section>
          ))}
          {isCookies && (
            <section className="legal-dialog-section">
              <h3 className="legal-dialog-section-heading">Manage preferences</h3>
              <div className="legal-dialog-cookie-options">
                <label className="legal-dialog-cookie-option">
                  <span>Essential cookies</span>
                  <span className="legal-dialog-cookie-badge">Always on</span>
                </label>
                <label className="legal-dialog-cookie-option">
                  <input
                    type="checkbox"
                    checked={cookiesAnalytics}
                    onChange={(e) => setCookiesAnalytics(e.target.checked)}
                  />
                  <span>Analytics cookies</span>
                </label>
                <label className="legal-dialog-cookie-option">
                  <input
                    type="checkbox"
                    checked={cookiesMarketing}
                    onChange={(e) => setCookiesMarketing(e.target.checked)}
                  />
                  <span>Marketing cookies</span>
                </label>
              </div>
              <button type="button" className="legal-dialog-save-btn" onClick={() => { alert('Preferences saved.'); onClose(); }}>
                Save cookie preferences
              </button>
            </section>
          )}
        </div>
      </div>
    </div>
  );

  return createPortal(dialog, document.body);
}
